import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PrimeNgLocaleService } from './primeng-locale.service';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [],
  providers: [
    PrimeNgLocaleService
  ]
})
export class PrimeNgLocaleModule {

  static forRoot(): ModuleWithProviders {
    return {
        ngModule: PrimeNgLocaleModule,
        providers: [
          PrimeNgLocaleService,
        ]
      };
  }

  static forChild(): ModuleWithProviders {
    return {
        ngModule: PrimeNgLocaleModule
      };
  }

}



// WEBPACK FOOTER //
// /dist/src/app/shared/primeng-locale/primeng-locale.module.ts